import { IManagingWindowsServiceInstance } from '../../api/models';
import { AppEnvironment } from '../../constants/AppEnvironment';
import { WindowsServiceStartType } from '../../constants/WindowsServiceStartType';
import { IStyledText, StyledText } from '../UIExtentions/Text';

function GetStartTypeProps(startType: string, environment: AppEnvironment): IStyledText {
    switch (startType) {
        case WindowsServiceStartType.Automatic:
            return {
                text: 'Auto',
                className: environment === AppEnvironment.Production ? 'text-success' : null,
            };
        case WindowsServiceStartType.Manual:
            return {
                text: 'Manual',
                className: environment === AppEnvironment.Production ? 'text-orange' : null,
            };
        case WindowsServiceStartType.Disabled:
            return {
                text: 'Disabled',
                className: 'text-muted',
            };
        default:
            return {
                text: startType,
            };
    }
}

export default function WindowsServiceStartTypeText(serverApp: IManagingWindowsServiceInstance) {
    const startTypeProps = GetStartTypeProps(serverApp.startType, serverApp.environment as AppEnvironment);

    return <StyledText {...startTypeProps} />;
}
